const stockQuote = (env) => {
  const apiUrl = env.apiUrl ? env.apiUrl : 'https://investors-api.nnnreit.com';
  Alpine.store('stockInfoData', {
    lastTradingDay: '',
    tables: {},
    fundamentalsData: [],
    dailyBarsData: [],
    intradayData: [],
    volumeData: [],
    financialData: [],
    priceRatioData: [],
    priceChangeData: [],
    dividendData: [],

    async fetchData() {
      // Fetch fundamental and daily bars data
      try {
        const fundamentals = await axios.get(`${apiUrl}/nnnfundamental/ltm`);
        
        const latestDailyBar = await axios.get(`${apiUrl}/nnndailybar/`);
        this.lastTradingDay = latestDailyBar.data.date;
        
        const intraday = await axios.get(`${apiUrl}/intraday/`);

        const lastTradingDate = new Date(latestDailyBar.data.date);
        lastTradingDate.setFullYear(lastTradingDate.getFullYear() - 1);
        const prevYearStart = lastTradingDate.toISOString().slice(0, 10);
        
        const dailyBars = await axios.get(`${apiUrl}/nnndailybar/date-range?start=${prevYearStart}&end=${lastTradingDate}`);
        
        this.fundamentalsData = fundamentals.data.data;
        this.dailyBarsData = dailyBars.data;
        this.updateTables();
        
      } catch (error) {
        console.error(error);
      } 
    },
    updateTables () {
      const stockInfoData = this;
      const fundamentalsData = this.fundamentalsData.data;
      const dailyBarsData = this.dailyBarsData;
      
      const volumeTableData = [];
      const financialTableData = [];
      const priceRatioTableData = [];
      const priceChangeTableData = [];
      const dividendTableData = [];
      
      const avgVolumes = this.calculateAverageDailyVolume(dailyBarsData);
      
      const volumeHighlightsData = this.calculateAverageDailyVolume(dailyBarsData);
      const priceChangeData = this.calculatePriceChange(dailyBarsData);
      const latestFundamentalsDate = fundamentalsData[0].period_ended.split('-');

      volumeTableData.push(
        {title: "One Day", avgDailyVolume: volumeHighlightsData.oneDay.toLocaleString(), percentSharesOutstanding: (volumeHighlightsData.oneDay / Number(fundamentalsData[0].common_shares_outstanding) * 100).toFixed(2) },
        {title: "One Month", avgDailyVolume: volumeHighlightsData.oneMonth.toLocaleString(), percentSharesOutstanding: (volumeHighlightsData.oneMonth / Number(fundamentalsData[0].common_shares_outstanding) * 100).toFixed(2) },
        {title: "Three Months", avgDailyVolume: volumeHighlightsData.threeMonths.toLocaleString(), percentSharesOutstanding: (volumeHighlightsData.threeMonths / Number(fundamentalsData[0].common_shares_outstanding) * 100).toFixed(2) },
        {title: "YTD", avgDailyVolume: volumeHighlightsData.ytd.toLocaleString(), percentSharesOutstanding: (volumeHighlightsData.ytd / Number(fundamentalsData[0].common_shares_outstanding) * 100).toFixed(2) },
        {title: "One Year", avgDailyVolume: volumeHighlightsData.oneYear.toLocaleString(), percentSharesOutstanding: (volumeHighlightsData.oneYear / Number(fundamentalsData[0].common_shares_outstanding) * 100).toFixed(2) },
      );

      financialTableData.push(
        { title: "", value: `${latestFundamentalsDate[1]}/${latestFundamentalsDate[2]}/${latestFundamentalsDate[0]}` },
        { title: "FFO/Share ($)", value: Number(fundamentalsData[0].ffo_share).toFixed(2) },
        { title: "LTM FFO / Share ($)", value: fundamentalsData.reduce((acc, cur) => acc + Number(cur.ffo_share), 0).toFixed(2) },
        { title: "AFFO / Share ($)", value: fundamentalsData[0].affo_per_share },
        { title: "Reported Operating FFO ($000)", value: fundamentalsData.reduce((acc, cur) => acc + Number(cur.operating_funds_from_operations), 0).toFixed(2) },
        { title: "Reported Operating FFO / Share ($)", value: Number(fundamentalsData[0].operating_ffo_per_share).toFixed(2) },
        { title: "Debt / Total Cap (%)", value: fundamentalsData[0].dept_and_preferred_tev },
      );
      
      priceRatioTableData.push(
        { title: "Price / FFO (x)", value: fundamentalsData[0].ffo_share },
        // { title: "FFO Yield (%)", value: "6.22" },
        { title: "Price / LTM FFO (x)", value: fundamentalsData.reduce((acc, cur) => acc + Number(cur.ffo_share), 0) },
        // { title: "Price / EBITDA (x)", value: "4.1" },
        // { title: "Price / Earnings (x)", value: "2.04" },
        { title: "Price / LTM Earnings (x)", value: fundamentalsData.reduce((acc, cur) => acc + Number(cur.basic_eps_before_extra), 0) },
      );
      
      priceChangeTableData.push(
        { title: "One Day", value: priceChangeData.oneDay },
        { title: "One Month", value: priceChangeData.oneMonth },
        { title: "Three Month", value: priceChangeData.threeMonth },
        { title: "YTD", value: priceChangeData.ytd },
        { title: "One Year", value: priceChangeData.oneYear },
      );

      dividendTableData.push(
        { title: "Quarterly Dividend ($)", value: fundamentalsData[0].common_dividends_declared_per_share },
        { title: "Dividend Yield (%)", value: (((fundamentalsData[0].common_dividends_declared_per_share * 4) / dailyBarsData[0].close) * 100).toFixed(1) },
        { title: "LTM Dividend ($)", value: fundamentalsData.reduce((acc, cur) => acc + Number(cur.common_dividends_declared_per_share), 0) },
        { title: "LTM Payout Ratio (%)", value: (Math.floor(fundamentalsData.reduce((acc, cur) => acc + Number(cur.ffo_payout), 0) / fundamentalsData.length * 100) / 100) }
      );

      stockInfoData.volumeData = volumeTableData;
      stockInfoData.financialData = financialTableData;
      stockInfoData.priceRatioData = priceRatioTableData;
      stockInfoData.priceChangeData = priceChangeTableData;
      stockInfoData.dividendData = dividendTableData;
      
      stockInfoData.tables.volumeTable.setData(volumeTableData);
      stockInfoData.tables.financialDataTable.setData(stockInfoData.financialData);
      stockInfoData.tables.priceRatioTable.setData(stockInfoData.priceRatioData)
      stockInfoData.tables.priceChangeTable.setData(stockInfoData.priceChangeData)
      stockInfoData.tables.dividendTable.setData(stockInfoData.dividendData);
    },
    calculateAverageDailyVolume(dailyBars) {
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);

      const oneDay = dailyBars[0].volume;

      const oneMonthStartDate = new Date(yesterday.getFullYear(), yesterday.getMonth() - 1, yesterday.getDate());
      const oneMonthEndDate = new Date(yesterday.getFullYear(), yesterday.getMonth(), yesterday.getDate());
      const oneMonthBars = dailyBars.filter(bar => new Date(bar.date) >= oneMonthStartDate && new Date(bar.date) <= oneMonthEndDate);
      const oneMonthVolume = oneMonthBars.reduce((total, bar) => total + bar.volume, 0);
      const oneMonth = (oneMonthVolume / oneMonthBars.length);

      const threeMonthsStartDate = new Date(yesterday.getFullYear(), yesterday.getMonth() - 3, yesterday.getDate());
      const threeMonthsEndDate = new Date(yesterday.getFullYear(), yesterday.getMonth(), yesterday.getDate());
      const threeMonthsBars = dailyBars.filter(bar => new Date(bar.date) >= threeMonthsStartDate && new Date(bar.date) <= threeMonthsEndDate);
      const threeMonthsVolume = threeMonthsBars.reduce((total, bar) => total + bar.volume, 0);
      const threeMonths = (threeMonthsVolume / threeMonthsBars.length);

      const startOfYear = new Date(yesterday.getFullYear(), 0, 1);
      const ytdBars = dailyBars.filter(bar => new Date(bar.date) >= startOfYear && new Date(bar.date) <= yesterday);
      const ytdVolume = ytdBars.reduce((total, bar) => total + bar.volume, 0);
      const ytd = (ytdVolume / ytdBars.length);

      const oneYearStartDate = new Date(yesterday.getFullYear() - 1, yesterday.getMonth(), yesterday.getDate());
      const oneYearEndDate = new Date(yesterday.getFullYear(), yesterday.getMonth(), yesterday.getDate());
      const oneYearBars = dailyBars.filter(bar => new Date(bar.date) >= oneYearStartDate && new Date(bar.date) <= oneYearEndDate);
      const oneYearVolume = oneYearBars.reduce((total, bar) => total + bar.volume, 0);
      const oneYear = (oneYearVolume / oneYearBars.length);

      return {
        oneDay: oneDay,
        oneMonth: oneMonth,
        threeMonths: threeMonths,
        ytd: ytd,
        oneYear: oneYear
      };
    },
    calculatePriceChange(dailyBars) {
      const newestDay = dailyBars[0];
      const oneDayPrior = dailyBars[1];
      const oneMonthPrior = dailyBars.find(day => new Date(day.date) <= new Date(newestDay.date).setMonth(new Date(newestDay.date).getMonth() - 1));
      const threeMonthsPrior = dailyBars.find(day => new Date(day.date) <= new Date(newestDay.date).setMonth(new Date(newestDay.date).getMonth() - 3));
      const ytd = dailyBars.find(day => new Date(day.date) <= new Date(newestDay.date).setMonth(0, 1));
      const oneYearPrior = dailyBars.find(day => new Date(day.date) <= new Date(newestDay.date).setFullYear(new Date(newestDay.date).getFullYear() - 1)) || dailyBars.filter(day => new Date(day.date) > new Date(newestDay.date).setFullYear(new Date(newestDay.date).getFullYear() - 1)).sort((a, b) => new Date(a.date) - new Date(b.date))[0];

      const oneDayChange = (newestDay.close - oneDayPrior.close) / oneDayPrior.close;
      const oneMonthChange = (newestDay.close - oneMonthPrior.close) / oneMonthPrior.close;
      const threeMonthChange = (newestDay.close - threeMonthsPrior.close) / threeMonthsPrior.close;
      const ytdChange = (newestDay.close - ytd.close) / ytd.close;
      const oneYearChange = (newestDay.close - oneYearPrior.close) / oneYearPrior.close;

      const formatPriceChange = (priceChange) => {
        const percentage = Math.round(Math.abs(priceChange) * 10000) / 100;
        return `${priceChange < 0 ? '(' : ''}${percentage.toLocaleString()}${priceChange < 0 ? ')' : ''}`;
      };

      const priceChangeData = {
        oneDay: formatPriceChange(oneDayChange),
        oneMonth: formatPriceChange(oneMonthChange),
        threeMonth: formatPriceChange(threeMonthChange),
        ytd: formatPriceChange(ytdChange),
        oneYear: formatPriceChange(oneYearChange),
      };
      
      return priceChangeData;
    }
  });
    // Fetch data on page load
  Alpine.store('stockInfoData').fetchData();

  const stockInfoData = Alpine.store("stockInfoData");

  // Volume table
  stockInfoData.tables.volumeTable = new Tabulator("#volumeTable", {
    data: stockInfoData.volumeData ? stockInfoData.volumeData : [],
    layout: "fitDataStretch",
    columns: [
      {title: "", field: "title", width: "50%", minWidth: "50%", headerSort: false},
      {title: "Avg Daily Volume", field: "avgDailyVolume", width: "25%", headerSort: false},
      {title: "% Of Shares Outstanding", field: "percentSharesOutstanding", width: "25%", headerSort: false}
    ]
  });

  // Financial table
  stockInfoData.tables.financialDataTable = new Tabulator("#financialDataTable", {
    reactiveData: true,
    data: stockInfoData.financialData ? stockInfoData.financialData : [],
    layout: "fitDataStretch",
    headerVisible: false,
    columns: [
      {title: "", field: "title", width: "50%", minWidth: "50%", headerSort: false},
      {title: "", field: "value", headerSort: false}
    ]
  });

  // Price ratio table
  stockInfoData.tables.priceRatioTable = new Tabulator("#priceRatioTable", {
    reactiveData: true,
    data: stockInfoData.priceRatioData ? stockInfoData.priceRatioData : [],
    layout: "fitDataStretch",
    headerVisible: false,
    columns: [
      {title: "", field: "title", width: "50%", minWidth: "50%", headerSort: false},
      {title: "", field: "value", headerSort: false}
    ]
  });

  // Price change table
  stockInfoData.tables.priceChangeTable = new Tabulator("#priceChangeTable", {
    reactiveData: true,
    data: stockInfoData.priceChangeData ? stockInfoData.priceChangeData : [],
    layout: "fitDataStretch",
    columns: [
      {title: "", field: "title", width: "50%", minWidth: "50%", headerSort: false},
      {title: "Price Change (%)", field: "value", headerSort: false}
    ]
  });

  // Dividend table
  stockInfoData.tables.dividendTable = new Tabulator("#dividendTable", {
    reactiveData: true,
    data: stockInfoData.dividendData ? stockInfoData.dividendData : [],
    layout: "fitDataStretch",
    headerVisible: false,
    columns: [
      {title: "", field: "title", width: "50%", minWidth: "50%", headerSort: false},
      {title: "", field: "value", headerSort: false}
    ]
  });
}